import React, { useEffect, useState, useRef } from "react";
import { getEvents } from "../../Api/updateApi";
import { FiCalendar, FiX, FiInfo } from "react-icons/fi"; // Changed FiBell to FiInfo for a professional/alert feel

const EventNotifications = () => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const [latestEvent, setLatestEvent] = useState(null);
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  // --- FUNCTIONALITY (UNCHANGED) ---

  useEffect(() => {
    if (!storedUser?.id) return;

    const fetchEvent = async () => {
      try {
        const res = await getEvents();
        if (res.data && res.data.length > 0) {
          // Sort events by newest first
          const sorted = res.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );

          // Find the newest event that is today or in the future
          const now = new Date();
          const futureEvent = sorted.find(
            (e) => new Date(e.date) >= new Date(now.toDateString())
          );

          if (!futureEvent) return; // no future events, do not show

          // Only show if it's different from the last shown event
          if (!latestEvent || latestEvent.id !== futureEvent.id) {
            setLatestEvent(futureEvent);

            // Delay 3s before showing (UNCHANGED)
            setTimeout(() => {
              setVisible(true);

              // Auto-hide after 8s
              setTimeout(() => {
                setVisible(false);
              }, 8000);
            }, 3000); // **3-SECOND DELAY CONFIRMED**
          }
        }
      } catch (err) {
        console.error("Failed to fetch events:", err);
      }
    };

    fetchEvent();
    // Poll every 1 min for new events
    const interval = setInterval(fetchEvent, 60000);
    return () => clearInterval(interval);
  }, [storedUser, latestEvent]);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!storedUser?.id || !latestEvent || !visible) return null;

  // --- PROFESSIONAL DESIGN REGENERATION (Visuals Only) ---

  // Utility function for better date formatting
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div
      ref={ref}
      // Positioned bottom-right (bottom-6 right-6)
      // Width: w-80 max-w-sm
      // Height: py-2 px-3 for compact layout.
      className={`fixed bottom-6 right-6 bg-white shadow-xl border-t-4 border-Dark rounded-lg py-2 px-3 w-80 max-w-sm flex items-center gap-3 z-[100]
        transform transition-all duration-500 ease-in-out
        ${
          visible
            ? "translate-x-0 opacity-100" // Visible state
            : "translate-x-[120%] opacity-0" // Hidden state (slide out to the right)
        }
      `}
      role="alert" // Accessibility role for an alert notification
    >
      {/* Icon: Using FiInfo for a professional alert, color matches border */}
      <FiInfo className="text-Dark text-xl flex-shrink-0" />{" "}
      {/* Adjusted margin-top */}
      <div className="flex-1 min-w-0">
        {/* Title: Complete title shown (no 'truncate' class), adjusted margin-bottom */}
        <h3
          className="font-bold text-base text-gray-800 leading-tight" // Adjusted leading to be tighter
          style={{ marginBottom: "2px" }}
        >
          {latestEvent.title}
        </h3>

        {/* Date: Professional, subdued color, reduced margin, aligned with title */}
        <p className="text-xs text-gray-500 flex items-center gap-1">
          {" "}
          {/* Removed mb-1 */}
          <FiCalendar className="text-Dark" size={12} />
          <span className="font-medium">{formatDate(latestEvent.date)}</span>
        </p>
      </div>
      {/* Close Button: Discreet and positioned neatly */}
      <button
        onClick={() => setVisible(false)}
        className="text-gray-400 hover:text-gray-800 p-1 -mt-1 -mr-1 transition-colors flex-shrink-0"
        aria-label="Close notification"
      >
        <FiX size={16} />
      </button>
    </div>
  );
};

export default EventNotifications;
